import { apiPath } from '../../constants';
import { addSuccessMessage } from 'actions';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const FEE_POST_REQUEST = 'POST_FEE_REQUEST';
export const FEE_POST_FAILURE = 'POST_FEE_FAILURE';
export const FEE_POST_SUCCESS = 'POST_FEE_SUCCESS';

export const postFee = (data) => {
    return function(dispatch) {
        dispatch(postRequest());
        const { competitionFeeList = [], ...feeData } = data;

        return axios(apiRequestOptions(apiPath.FEES.POST, feeData))
            .then(transformHttpResponse)
            .then(response => {
                const fee = response.data;
                const feeIri = `/api/competition_fees/${fee.id}`;

                const itemRequests = competitionFeeList.map(item =>
                    axios(apiRequestOptions(apiPath.FEE_ITEMS.POST, { ...item, competitionFee: feeIri }))
                        .then(transformHttpResponse)
                );

                return Promise.all(itemRequests).then(() => fee);
            })
            .then(fee => {
                dispatch(postSuccess(fee));
                dispatch(addSuccessMessage('Fee successfully added'));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(postFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const postRequest = () => ({ type: FEE_POST_REQUEST });
const postFailure = error => ({ type: FEE_POST_FAILURE, error });
const postSuccess = fee => ({ type: FEE_POST_SUCCESS, fee });
